import React from "react";
import { normalizeProps } from "./utils/normalizeProps";

const AddDocumentIcon = (props) => {
  return (
    <svg
      width="13"
      height="15"
      viewBox="0 0 13 15"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...normalizeProps(props)}
    >
      <path
        d="M7.8 0V3.97059C7.8 4.70155 8.38203 5.29412 9.1 5.29412H13V12.7941C13 13.5251 12.418 14.1176 11.7 14.1176H7.57713C8.25776 13.2786 8.66667 12.2026 8.66667 11.0294C8.66667 8.34921 6.53256 6.17647 3.9 6.17647C3.44932 6.17647 3.01325 6.24015 2.6 6.35915V1.32353C2.6 0.592564 3.18203 0 3.9 0H7.8ZM8.66667 0.220588V3.97059C8.66667 4.21424 8.86068 4.41176 9.1 4.41176H12.7833L8.66667 0.220588ZM7.8 11.0294C7.8 13.2223 6.05391 15 3.9 15C1.74609 15 0 13.2223 0 11.0294C0 8.83652 1.74609 7.05882 3.9 7.05882C6.05391 7.05882 7.8 8.83652 7.8 11.0294ZM4.33333 9.26471C4.33333 9.02105 4.13932 8.82353 3.9 8.82353C3.66068 8.82353 3.46667 9.02105 3.46667 9.26471V10.5882H2.16667C1.92734 10.5882 1.73333 10.7858 1.73333 11.0294C1.73333 11.2731 1.92734 11.4706 2.16667 11.4706H3.46667L3.46667 12.7941C3.46667 13.0378 3.66068 13.2353 3.9 13.2353C4.13932 13.2353 4.33333 13.0378 4.33333 12.7941V11.4706H5.63333C5.87266 11.4706 6.06667 11.2731 6.06667 11.0294C6.06667 10.7858 5.87266 10.5882 5.63333 10.5882H4.33333V9.26471Z"
        fill="white"
      />
    </svg>
  );
};
export default AddDocumentIcon;
